import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function ArabicFAQs() {
  return (
    <section className="my-10">
      <div className="divider text-4xl text-slate-500 my-20">FAQs</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7 lg:mx-32">
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              কোর্সে কি যে কেউ ভর্তি হতে পারবে?
            </p>
            <p>
              হ্যাঁ, ১৫+ বয়সী যে কেউ ভর্তি হতে পারবে। জেনারেল স্টুডেন্ট ও
              মাদরাসার ছাত্র, সবার জন্য এই কোর্সগুলো বিশেষ উপযোগী হবে।
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">ক্লাস কিভাবে হবে?</p>
            <p>
              গুগল মিটে সপ্তাহে ২দিন লাইভ ক্লাস হবে। পুরুষ-মহিলা আলাদা লিংকে
              জয়েন করবেন। ক্লাস শেষে রেকর্ড দেওয়া হবে।{" "}
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              কিভাবে হোমওয়ার্ক ও পরীক্ষার উত্তর জমা দিতে হবে?
            </p>
            <p>
              হোমওয়ার্ক, এসাইনমেন্ট ও পরীক্ষা খাতায় লেখে গুগল ক্লাসরুমে জমা দিতে
              হবে।
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              আরবি ভাষা শেখার জন্য পূর্বের কোনো অভিজ্ঞতার প্রয়োজন আছে কি?
            </p>
            <p>
              কোনো পূর্ব অভিজ্ঞতার প্রয়োজন নেই। আমরা একদম শূন্য বা বেসিক লেভেল
              থেকে শুরু করব, যেন আরবি ভাষা সহজে আয়ত্ত করতে পারেন।
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              শিক্ষকের সাথে সরাসরি প্রশ্ন করার বা সমস্যা সমাধানের সুযোগ আছে কি?
            </p>
            <p>
              হা, লাইভ ক্লাসের নির্দিষ্ট সময়ে শিক্ষককে সরাসরি প্রশ্ন করে নিজের
              সমস্যাগুলো সমাধান করে নিতে পারবেন। এছাড়া ক্লাসের বাইরেও টেলিগ্রাম
              গ্রুপে সাপোর্ট দেওয়া হবে।
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
